/**
=========================================================
* MD UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/MD-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the MDware.
*/
// import { useAppServices } from "hook/services";
import { useEffect, useState } from "react";
import { useAgencyInfo } from "context/agency";
import { useAppServices } from "hook/services";
import { Switch } from "@mui/material";
import { useParams } from "react-router-dom";

export default function SnapshotData() {
  const AppService = useAppServices();
  const [agency] = useAgencyInfo();
  const { locationId } = useParams()
  const [processing, setProcessing] = useState(true);
  const [main_data, setmain_data] = useState([]);
  const [data, setdata] = useState({
    columns: [
      { Header: "name", accessor: "name" },
      { Header: "email", accessor: "email" },
      { Header: "Default Ticket Agent", accessor: "default_ticket_agent" },
      { Header: "Default Forum Agent", accessor: "default_forum_agent" },
    ],

    rows: [],
  });
  const UpdateUser = async (_id, type, value) => {
    if (type == 'default_ticket_agent') {
      var payload = {
        _id, _id,
        default_ticket_agent: value,

      }
    } else {
      var payload = {
        _id, _id,
        default_forum_agent: value,

      }
    }
    const { response } = await AppService.csm_users.update({
      payload: payload,
    });
    if (response) {
      GetAgencyUsers()
    }
  }
  const GetAgencyUsers = async (e) => {
    const { response } = await AppService.csm_users.filter({
      query: `ghl_locations=${locationId}`,
    });
    var temp_data = [];
    if (response) {
      setmain_data(response.data);
      for (let index = 0; index < response.data.length; index++) {
        const element = response.data[index];
        var temp = {
          name: element.username,
          email: element.email,
          default_ticket_agent: <>
            <Switch defaultChecked={element.default_ticket_agent} onChange={(e) => UpdateUser(element._id, "default_ticket_agent", e.target.checked)} />
          </>,
          default_forum_agent: <>
            <Switch defaultChecked={element.default_forum_agent} onChange={(e) => UpdateUser(element._id, "default_forum_agent", e.target.checked)} />
          </>,
        };
        temp_data.push(temp);
      }
      setdata({
        columns: [
          { Header: "name", accessor: "name" },
          { Header: "email", accessor: "email" },
          { Header: "Default Ticket Agent", accessor: "default_ticket_agent" },
          { Header: "Default Forum Agent", accessor: "default_forum_agent" },
        ],
        rows: temp_data,
      });
    }

    setProcessing(false);
  };
  const onLoad = () => {
    GetAgencyUsers();
  };
  useEffect(() => {
    onLoad();
  }, []);
  return {
    data: data,
    main_data: main_data,
    processing: processing,
    handleRefresh: GetAgencyUsers,
  };
}
